import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getIsFetchingJobs = (state: IStore) => state.infoJobs.isFetching;
const getIsFetchJobsFailed = (state: IStore) => state.infoJobs.isFetchFailed;
const getJobsContent = (state: IStore) => state.infoJobs.content;

export {
  getIsFetchingJobs,
  getIsFetchJobsFailed,
  getJobsContent,
};


// WEBPACK FOOTER //
// ./src/components/InfoJobs/Redux/selectors.tsx